import {IBaseOption} from './types'

export const LANGUAGE_OPTIONS: IBaseOption[] = [
  {value: 'tr-TR', label: 'Türkçe'},
  {value: 'en-US', label: 'English'},
  {value: 'es-ES', label: 'Español'},
  {value: 'pt-PT', label: 'Português'},
  {value: 'fr-FR', label: 'Français'},
]
